/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "../../style/home.css";
import { BASE_URL } from "../../utils/config";
import "primeicons/primeicons.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { pdfjs } from 'react-pdf';
import SessionLogout from "../../components/animation/sessionLogout";
import TelegramWidget from '../../components/widget/telegramWidget';
import Loading from '../../components/loading';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.6.82/pdf.worker.mjs`;

const PdfReportViewer = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const pdfID = location.state?.id;
  const [pdfData, setPdfData] = useState(null);
  const [userdetails, setUserDetails] = useState({});
  const [sessionExpired, setSessionExpired] = useState(false)
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchReportData();
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if (e.ctrlKey && (e.key === 's' || e.key === 'p')) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  const fetchReportData = async () => {
    if (!pdfID) return;

    try {
      setLoading(true);
      const details = JSON.parse(localStorage.getItem('userData'));
      setUserDetails(details)
      const token = localStorage.getItem('AUTH_TOKEN');
      const response = await axios.get(`${BASE_URL}/getPdfreport/${pdfID}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      // const pageImages = [];
      console.log("response.data.performanceFile", response.data.performanceFile)
      setLoading(false);
      setPdfData(response.data.performanceFile[0]);


    } catch (error) {
      console.error(`Error fetching data for ${pdfID}:`, error);
      if (axios.isAxiosError(error) && error.response) {
        console.log("error", error);

        if (error.response.status === 403) {
          setLoading(false);
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }
        else if (error.response.status === 401) {
          setLoading(false);
          setSessionExpired(true)
          setTimeout(() => {
            setSessionExpired(false)
            navigate('/login')
          }, 5000)
        }

      } else {
        setLoading(false);
        console.log("error", error);
      }
    }
  };

  if (loading) {
  return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
  );
}

if (loading) {
  return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
  );
}


  return (
    <>
      <div style={{ marginTop: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

        {loading ?
          <div style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
          }}>
          </div>
          : pdfData ? (
            <div style={{ width: "80%" }}>
            <button
              className="rkb-back-btn"
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
              {pdfData.upload_file.map((imageBase64, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  <img
                    src={imageBase64}
                    alt={`PDF page ${index + 1}`}
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
              ))}
            </div>
          ) : null

        }

      </div>
      {userdetails.usertype_id == 1 ?
        <TelegramWidget />
        : null}
      
      {sessionExpired ? <SessionLogout /> : null}
    </>
  );
};

export default PdfReportViewer;
